import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Input from '@carvana/forms/Input';

const Wrapper = styled.div`
  margin-bottom: 8px;
  [class^='ErrorMessage'] {
    color: var(--cvna-color-red-2);
    font-size: 12px;
    display: ${props => (props.hideErrorMessage ? 'none' : 'block')};
  }
  .show-error-icon {
    [for^='co'] {
      color: var(--cvna-color-red-2);
    }
    input {
      border-color: var(--cvna-color-red-2);
    }
    label {
      color: var(--cvna-color-red-2);
    }
    svg {
      color: var(--cvna-color-red-2) !important;
    }
  }
`;

const Disabled = css`
  -webkit-text-fill-color: #aab1c7;
  font-weight: 390;
  background: #ffffff;
`;

const StyledInput = styled(Input)`
  > input {
    -webkit-text-fill-color: ${props => props.theme.carvana.blue.dark};
  }

  > input:-webkit-autofill {
    -webkit-text-fill-color: ${props => props.theme.carvana.blue.dark};
  }

  span.input-error-icon {
    svg {
      color: var(--cvna-color-red-2) !important;
      width: ${props => props.isCosigner ? '20px' : '15px'};
      height: ${props => props.isCosigner ? '20px' : '15px'};
    }
  }

  span.input-validated-icon {
    svg {
      width: ${props => props.isCosigner ? '20px' : '15px'};
      height: ${props => props.isCosigner ? '20px' : '15px'};
      top: 8px;
      right: 4px;
      color:  var(--cvna-color-green-2);
    }
  }

  #coStreet2,
  #coCity,
  #coZip
  {
    font-size: 16px;
    ${props => props.isDisabled && Disabled}
  }
`;

const InputTip = styled.div`
  color: ${props => props.theme.carvana.gray.dark};
  font-size: 12px;
  margin-top: 5px;
`;

const InputTipNote = styled.span`
  color: ${props => props.theme.carvana.gray.dark};
  font-style: normal;
`;

const BaseNext = props => {
  const {
    onChange,
    value,
    error,
    'data-cv-test-override': cvDataTestOverride,
    touched,
    isDisabled,
    id,
    type,
    labelText,
    textMask,
    inputTip,
    maxLength,
    isCosigner,
    hideErrorMessage
  } = props;

  const [isFocused, setIsFocused] = useState(false);

  const onFocus = () => {
    setIsFocused(true);
  };

  const baseOnBlur = e => {
    setIsFocused(false);

    const { onBlur } = props;
    if (onBlur) onBlur(e);
  };

  return (
    <Wrapper isCosigner={isCosigner} hideErrorMessage={hideErrorMessage}>
      <StyledInput
        isDisabled={isDisabled}
        onChange={onChange}
        data-cv-test={cvDataTestOverride}
        onBlur={baseOnBlur}
        value={value || ''}
        touched={touched}
        error={error}
        id={id}
        type={type}
        labelText={labelText}
        textMask={textMask}
        onFocus={onFocus}
        maxLength={maxLength}
        autoComplete="off"
        isCosigner={isCosigner}
      />
      {inputTip && isFocused && !error && (
        <InputTip>
          <InputTipNote>Note: </InputTipNote>
          {inputTip}
        </InputTip>
      )}
    </Wrapper>
  );
};

BaseNext.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  touched: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isDisabled: PropTypes.bool,
  id: PropTypes.string,
  type: PropTypes.string,
  labelText: PropTypes.string,
  'data-cv-test-override': PropTypes.string,
  textMask: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)])
  ),
  inputTip: PropTypes.string,
  maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isCosigner: PropTypes.bool
};

BaseNext.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  value: '',
  touched: false,
  error: false,
  isDisabled: false,
  id: '',
  type: '',
  labelText: '',
  'data-cv-test-override': '',
  textMask: null,
  inputTip: null,
  maxLength: 50,
  isCosigner: false
};

export default BaseNext;
